import Alpine from "alpinejs"
import { slotBookingQuotaBuilder } from "../supports/events/slotBookingQuotaBuilder"

;(window as any).Alpine = Alpine

// Registered before start() so `x-data="slotBookingQuotaBuilder(...)"` resolves.
Alpine.data("slotBookingQuotaBuilder", slotBookingQuotaBuilder)

Alpine.start()
